export default __webpack_public_path__ + "static/media/rob_5.1484463e.webp";